import { AxiosError } from 'axios';
import { GET_COORDINATOR_APPEAL_LISTING_URL } from '../../constants/apiUrls';
import { GET_COORDINATOR_APPEAL_LISTING_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import { ApiPathParam } from '../../models/SearchParamSchema';
import { Pageable, PageDataSort } from '../group-special-consideration/usePostGroupSCListing';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ResultDataContentObject {
  appealOutcomeDateTime: string;
  dateOfApplication: string;
  examLevel: string;
  internalTransactionRef: string;
  applicationStatus: string;
  applicationId: string;
  uuid: string;
  nricFin: string;
  candidateName: string;
  totalPayableFee: string;
  coordinatorName: null;
}

export interface ResultData {
  content: ResultDataContentObject[];
  pageable: Pageable;
  last: boolean;
  totalElements: number;
  totalPages: number;
  first: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  sort: PageDataSort[];
  empty: boolean;
}

export interface CoordinatorAppealListingResponse {
  resultReleaseOpen: boolean;
  appealOpen: boolean;
  resultPage: ResultData;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: CoordinatorAppealListingResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  apiParams: ApiPathParam;
}

export const useGetCoordinatorAppealListing = ({ onSuccess, onError, apiParams }: Input) => {
  const getCoordinatorAppealListing = async () => {
    const res = await axiosClient.get<CoordinatorAppealListingResponse>(
      GET_COORDINATOR_APPEAL_LISTING_URL(apiParams)
    );
    return res.data;
  };

  return useCustomQuery(GET_COORDINATOR_APPEAL_LISTING_QUERY_KEY, getCoordinatorAppealListing, {
    onSuccess,
    onError,
  });
};
